// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FavoriteItemNav_icon__UJB7q {
  color: var(--accent-color);
  cursor: pointer;
}
.FavoriteItemNav_icon__UJB7q.FavoriteItemNav_white-theme__Yk\\+Vw {
  color: white;
}

.FavoriteItemNav_drawer__36\\+Dt {
  width: 349px;
  height: 100vh;
  overflow-y: auto;
  background: var(--background-color-1);
}
.FavoriteItemNav_drawer__36\\+Dt .FavoriteItemNav_drawer__header__tOcYJ {
  display: flex;
  height: var(--navbar-height);
  padding: 0px 16px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  border-bottom: 1px solid var(--light-grey);
  background: var(--background-color-2);
  color: var(--accent-color);
}
.FavoriteItemNav_drawer__36\\+Dt .FavoriteItemNav_drawer__header--title__UviQ6 {
  font-size: 20px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal;
}
.FavoriteItemNav_drawer__36\\+Dt .FavoriteItemNav_drawer__content__x6c6X {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  flex: 1 0;
  align-self: stretch;
}
.FavoriteItemNav_drawer__36\\+Dt .FavoriteItemNav_drawer__content--login-text__7PK9H {
  color: var(--accent-color);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.FavoriteItemNav_drawer__36\\+Dt .FavoriteItemNav_drawer__content--login-text__7PK9H a {
  color: var(--accent-color);
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}
.FavoriteItemNav_drawer__36\\+Dt .FavoriteItemNav_drawer__content--item__BZEea {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
  align-self: stretch;
  max-height: 655px;
  overflow-y: scroll;
}
.FavoriteItemNav_drawer__36\\+Dt .FavoriteItemNav_drawer__content--item__BZEea.FavoriteItemNav_hidden__Pa4Gz {
  display: none;
}
.FavoriteItemNav_drawer__36\\+Dt .FavoriteItemNav_drawer__content--list__6Gs7C {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
}
.FavoriteItemNav_drawer__36\\+Dt .FavoriteItemNav_drawer__content--list__6Gs7C > div {
  background-color: var(--background-color-2);
}

.FavoriteItemNav_login-modal__jCIZF {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Layout/Navbar/Components/FavoriteItemNav/FavoriteItemNav.module.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,eAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,qCAAA;AAAF;AAGI;EACE,aAAA;EACA,4BAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,0CAAA;EACA,qCAAA;EACA,0BAAA;AADN;AAGM;EACE,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AADR;AAKI;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;AAHN;AAKM;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAKQ;EACE,0BAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AAHV;AAOM;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AALR;AAOQ;EACE,aAAA;AALV;AASM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAPR;AASQ;EACE,2CAAA;AAPV;;AAaA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAVF","sourcesContent":[".icon {\n  color: var(--accent-color);\n  cursor: pointer;\n\n  &.white-theme {\n    color: white;\n  }\n}\n\n.drawer {\n  width: 349px;\n  height: 100vh;\n  overflow-y: auto;\n  background: var(--background-color-1);\n\n  .drawer {\n    &__header {\n      display: flex;\n      height: var(--navbar-height);\n      padding: 0px 16px;\n      justify-content: space-between;\n      align-items: center;\n      flex-shrink: 0;\n      align-self: stretch;\n      border-bottom: 1px solid var(--light-grey);\n      background: var(--background-color-2);\n      color: var(--accent-color);\n\n      &--title {\n        font-size: 20px !important;\n        font-style: normal;\n        font-weight: 700 !important;\n        line-height: normal;\n      }\n    }\n\n    &__content {\n      display: flex;\n      padding: 16px;\n      flex-direction: column;\n      align-items: stretch;\n      gap: 24px;\n      flex: 1 0 0;\n      align-self: stretch;\n\n      &--login-text {\n        color: var(--accent-color);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n\n        a {\n          color: var(--accent-color);\n          font-weight: 700;\n          text-decoration: underline;\n          cursor: pointer;\n        }\n      }\n\n      &--item {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n        gap: 20px;\n        align-self: stretch;\n        max-height: 655px;\n        overflow-y: scroll;\n        \n        &.hidden {\n          display: none;\n        }\n      }\n\n      &--list {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n        align-self: stretch;\n\n        > div {\n          background-color: var(--background-color-2);\n        }\n      }\n    }\n  }\n}\n.login-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `FavoriteItemNav_icon__UJB7q`,
	"white-theme": `FavoriteItemNav_white-theme__Yk+Vw`,
	"drawer": `FavoriteItemNav_drawer__36+Dt`,
	"drawer__header": `FavoriteItemNav_drawer__header__tOcYJ`,
	"drawer__header--title": `FavoriteItemNav_drawer__header--title__UviQ6`,
	"drawer__content": `FavoriteItemNav_drawer__content__x6c6X`,
	"drawer__content--login-text": `FavoriteItemNav_drawer__content--login-text__7PK9H`,
	"drawer__content--item": `FavoriteItemNav_drawer__content--item__BZEea`,
	"hidden": `FavoriteItemNav_hidden__Pa4Gz`,
	"drawer__content--list": `FavoriteItemNav_drawer__content--list__6Gs7C`,
	"login-modal": `FavoriteItemNav_login-modal__jCIZF`
};
export default ___CSS_LOADER_EXPORT___;
